import { WallboxChargingPhases, WallboxStatuses } from '@vi-iot/client/index';

export namespace WallboxSystem {
  export function getChargingPhaseStatusTranslationKey(
    phase: string,
    chargingStatus: string
  ): string {
    if (chargingStatus !== WallboxStatuses.charging) {
      return '';
    }

    switch (phase) {
      case WallboxChargingPhases.single:
        return '+INSTALLATIONS.INSTALLATION.WALLBOX.PHASES.SINGLE';

      case WallboxChargingPhases.multiple:
        return '+INSTALLATIONS.INSTALLATION.WALLBOX.PHASES.MULTIPLE';

      case WallboxChargingPhases.none:
      default:
        return '';
    }
  }
}
